// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subject-container {
  position: relative;
  width: 100%;
  max-width: 500px;
}

.subject-input {
  width: 100%;
  padding-left: 0;
  padding-right: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  background: linear-gradient(to right, white 80%, rgba(255, 255, 255, 0));
  border: none;
}

.subject-input::placeholder {
  color: #979797;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/EmailV2/EmailSubject.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,wEAAA;EACA,YAAA;AACJ;;AAEA;EACI,cAAA;AACJ","sourcesContent":[".subject-container {\n    position: relative;\n    width: 100%;\n    max-width: 500px;\n}\n\n.subject-input {\n    width: 100%;\n    padding-left: 0;\n    padding-right: 20px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n    background: linear-gradient(to right, white 80%, rgba(255, 255, 255, 0));\n    border: none;\n}\n\n.subject-input::placeholder {\n    color: #979797;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
